// Story 10.4 — Tabla de top errores con link placeholder a logs.

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { AnalyticsTopError } from '@/lib/analytics-types';
import { formatRelative } from '@/lib/relative-time';

interface Props {
  errors: AnalyticsTopError[];
}

export function TopErrorsTable({ errors }: Props): React.ReactElement {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Top errores</CardTitle>
      </CardHeader>
      <CardContent>
        {errors.length === 0 ? (
          <p className="text-sm text-muted-foreground">Sin errores en el periodo.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border text-left text-xs uppercase tracking-wide text-muted-foreground">
                  <th className="py-2 pr-2">Code</th>
                  <th className="py-2 pr-2">Mensaje</th>
                  <th className="py-2 pr-2 text-right">Count</th>
                  <th className="py-2 pr-2">Último</th>
                </tr>
              </thead>
              <tbody>
                {errors.map((err) => (
                  <tr
                    key={`${err.code}::${err.message}`}
                    className="border-b border-border/50 last:border-b-0"
                  >
                    <td className="py-2 pr-2 font-mono text-xs">{err.code}</td>
                    <td className="py-2 pr-2 text-muted-foreground">{err.message || '—'}</td>
                    <td className="py-2 pr-2 text-right font-mono">{err.count}</td>
                    <td className="py-2 pr-2 text-xs text-muted-foreground">
                      {formatRelative(err.lastAt)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
